<!-- #9519 ion-card seems to be interfering with load new items in certain circumstances -->
<!-- <ion-card>

<ion-card-content class="ion-no-padding" [ngSwitch]="item.itemType">
  -->
  <div class="card" snInViewport [inViewportOptions]="inViewportOptions" (inViewportChange)="onInViewportChange($event)">
    <div class="card-content">
      @switch (item.itemType) {
        @case (0) {
          <app-article-item
            [item]="itemAsChannelArticleItemViewModel"
            [showPublisherLink]="!disablePublisherLink"
            (selectItem)="selectItem.emit($event)"
            (selectChannel)="selectChannel.emit($event)"
            (openAttachment)="openAttachment.emit($event)"
          (getThumb)="getThumb.emit($event)"></app-article-item>
          <app-item-toolbar
            [item]="item"
            (toggleItemDone)="toggleItemDone.emit($event)"
            (shareItem)="shareItem.emit($event)"
            (translateItem)="translateItem.emit($event)"
            (showOriginalItem)="showOriginalItem.emit($event)"
            (reactWith)="reactWith.emit($event)">
          </app-item-toolbar>
        }
        @case (1) {
          <app-announcement-item
            [item]="itemAsAnnouncementItemViewModel"
            [showPublisherLink]="!disablePublisherLink"
            (selectItem)="selectItem.emit($event)"
            (selectStudent)="selectStudent.emit($event)"
            (openAttachment)="openAttachment.emit($event)"
          (getThumb)="getThumb.emit($event)"></app-announcement-item>
          <app-item-toolbar
            [item]="item"
            (toggleItemDone)="toggleItemDone.emit($event)"
            (shareItem)="shareItem.emit($event)"
            (translateItem)="translateItem.emit($event)"
            (showOriginalItem)="showOriginalItem.emit($event)"
            (reactWith)="reactWith.emit($event)">
          </app-item-toolbar>
        }
        @case (2) {
          <app-attendance-item
            [item]="itemAsAttendanceItemViewModel"
            [showPublisherLink]="!disablePublisherLink"
            (selectItem)="selectItem.emit($event)"
            (selectAttendanceAlerts)="selectAttendanceAlerts.emit($event)"
            (openAttachment)="openAttachment.emit($event)"
          (getThumb)="getThumb.emit($event)"></app-attendance-item>
          <app-item-toolbar
            [item]="item"
            (toggleItemDone)="toggleItemDone.emit($event)"
            (shareItem)="shareItem.emit($event)"
            (translateItem)="translateItem.emit($event)"
            (showOriginalItem)="showOriginalItem.emit($event)"
            (reactWith)="reactWith.emit($event)">
          </app-item-toolbar>
        }
        @case (3) {
          <app-payment-item
            [item]="itemAsPaymentItemViewModel"
            [showPublisherLink]="!disablePublisherLink"
            (selectItem)="selectItem.emit($event)"
            (selectPaymentRequests)="selectPaymentRequests.emit($event)"
            (openAttachment)="openAttachment.emit($event)"
            (getThumb)="getThumb.emit($event)"
          (showPayment)="showPayment.emit($event)"></app-payment-item>
          <app-item-toolbar
            [item]="item"
            (toggleItemDone)="toggleItemDone.emit($event)"
            (shareItem)="shareItem.emit($event)"
            (translateItem)="translateItem.emit($event)"
            (showOriginalItem)="showOriginalItem.emit($event)"
            (reactWith)="reactWith.emit($event)">
          </app-item-toolbar>
        }
        @case (4) {
          <app-slip-item
            [item]="itemAsSlipItemViewModel"
            [showPublisherLink]="!disablePublisherLink"
            (selectItem)="selectItem.emit($event)"
            (selectPaymentRequests)="selectPaymentRequests.emit($event)"
            (openAttachment)="openAttachment.emit($event)"
            (getThumb)="getThumb.emit($event)"
          (showSlip)="showSlip.emit($event)"></app-slip-item>
          <app-item-toolbar
            [item]="item"
            (toggleItemDone)="toggleItemDone.emit($event)"
            (shareItem)="shareItem.emit($event)"
            (translateItem)="translateItem.emit($event)"
            (showOriginalItem)="showOriginalItem.emit($event)"
            (reactWith)="reactWith.emit($event)">
          </app-item-toolbar>
        }
        @default {
          <app-unknown-item
            [item]="itemAsUnknownItemViewModel"
            [showPublisherLink]="!disablePublisherLink"
            (selectItem)="selectItem.emit($event)"
            (openAttachment)="openAttachment.emit($event)"
          (getThumb)="getThumb.emit($event)"></app-unknown-item>
        }
      }
    </div>
  </div>

<!-- </ion-card-content>
</ion-card> -->
